(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("SocialWall");

  Components.create('SocialWall', {

    Selectors: {
	  Container: '.social-wall-container',
	  GetMore: '.social-wall-get-more',
	  BottomItem: '.social-wall-bottom-item',
	  SocialPost: '.social-post'
	},
	  
    maxPage: 0,
    
    enableGetMore: function(pageSize) {
      var _this = this;
      $(_this.Selectors.GetMore).on('click', function (e) {
    	e.preventDefault();
    	
    	var $getMore = $(_this.Selectors.GetMore);
	    var url = $getMore.data('url');
	    var postsNum = $(_this.Selectors.Container).children(_this.Selectors.SocialPost).length;
	    var nextPage = postsNum / pageSize + 1;
	    
	    var ajaxData = {
	      params: {
    	    pageNumber: nextPage,
    	    pageSize: pageSize
	      }
	    };
	    axios.get(url, ajaxData)
	      .then(function (response) {
					$getMore.before(response.data);
	        if(nextPage + 1 > _this.maxPage) {
	          $getMore.addClass('hide');
	          $(_this.Selectors.BottomItem).removeClass('hide');
	        }
	      })
	      .catch(function (error) {
	        logger.d("Couldn't get social data: ", error);
	      })
      });
    },

    init: function() {
      this.maxPage = 7; 
      this.enableGetMore(4);
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
